import { ExamItemOption } from '~/src/types/exam/examItem';

export interface ComputedExamQuestionItem {
  id: number;
  score: number;
  serialNumber: number;
  analyze: string;
  options: ExamItemOption[];
  isTagged: boolean;
  questionType: number;
  answerType: number;
  computedQuestionType: number;
  questTypeName: string;
  questionTitle: string;
  answer: string[];
  materialText: string;
  sortSon: number;
  belongPage: number;
  rightAnswer: string[];
  like: number;
  disabled: boolean;
  result?: number;
  isCheck?: boolean;
  lectureReadScore?: number;
}

export interface ComputedExamine {
  id: number;
  title: string;
  lenTime: number;
  totalQuestion: number;
  totalScore: number;
  submitLimitNum: string;
  sheetName: string;
  machineType: string;
  isOnce: boolean;
  isGtOne: boolean;
  alreadyAnswersNum: string;
  answersNum: number;
  examTime: number;
}

export interface ComputedAnswerItem {
  answer: string[];
  answerImgs: string[];
  answerText: string[];
  answerType: number;
  done: boolean;
  id: number;
  open: string;
  page: string;
  qindex: number;
  questionType: number;
}

export interface ComputedProgress {
  answer: ComputedAnswerItem[];
  index: string;
  markQuestionIds: string[];
  qid: string;
  size: string;
  time: string;
}

export interface ComputedExamInfo {
  questionList: ComputedExamQuestionItem[];
  examine: ComputedExamine;
  progress: ComputedProgress;
}

export enum ComputedQuestionType {
  UnKnow = 0,
  SingleChoice = 1,
  MaterialSingleChoice = 2,
  MultipleChoice = 3,
  MaterialMultipleChoice = 4,
  Fill = 5,
  RichText = 6,
  MaterialRichText = 7,
}

export enum QuestionCollectStatus {
  Unlike = 0,
  Like = 1,
}

export interface ExamAnswerPageMeta {
  date?: string;
}
